/**
 * Vite dev interop shim: p-retry@4 is CJS and exposes AbortError on module.exports,
 * which breaks `import { AbortError } from 'p-retry'` in the browser.
 */
import pRetryImport from 'p-retry-original';

type PRetryFn = typeof pRetryImport & {
  AbortError: new (message?: string | Error) => Error;
  default?: PRetryFn;
};

const pRetry = (pRetryImport as PRetryFn).default ?? (pRetryImport as PRetryFn);

export default pRetry;
export const AbortError = pRetry.AbortError;
